<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="admin-page-content">
                <div class="page-title-container">
                </div>
                <div class="internal-container">
                    <div class="row pageFilters">
                        <div class="col-sm-12 col-md-4 customTab">
                            <div class="row">
                                <button id="" type="button" class="btnDiscussion ml-2 btn btn-primary pull-left" v-on:click.prevent="changeTab('discussion')">Discussion</button>
                                <button id="" type="button" class="btnAttachment ml-2 btn btn-primary pull-left" v-on:click.prevent="changeTab('attachments')">Attachment</button>
                            </div>
                        </div>

                        <div v-show="currentTab == 'discussion'" class="col-sm-12 col-md-2 serch-discussion-tab">
                        </div>

                        <div v-show="currentTab == 'attachments'" class="col-sm-12 col-md-2 serch-attachment-tab">
                        </div>

                        <div v-show="currentTab == 'savethedate'" class="col-sm-12 col-md-4 serch-event-tab">
                        </div>

                        <div v-show="currentTab == 'discussion'" class="col-sm-6 col-md-2 sortByField">
                        </div>
                        <div v-show="currentTab == 'discussion'" class="col-sm-6 col-md-2 sortByField">
                        </div>
                        <div v-show="currentTab == 'discussion'" class="col-sm-6 col-md-2 sortByField">
                        </div>
                        <div v-show="currentTab == 'attachments'" class="col-sm-6 col-md-2 sortByField"></div>
                        <div v-show="currentTab == 'attachments'" class="col-sm-6 col-md-2 sortByField"></div>
                        <div v-show="currentTab == 'savethedate'" class="col-sm-6 col-md-2 sortByField">

                        </div>
                        <div v-show="currentTab == 'attachments'" class="col-sm-12 col-md-2">
                            <button v-if="is_Grid == true" class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon2.png"></button>
                            <button v-if="is_Grid == false"  class="btn pull-right" v-on:click.prevent="gridChange('single')"><img src="/static/images/listview-icon1.png"></button>
                            <button v-if="is_Grid == false" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon2.png"></button>
                            <button v-if="is_Grid == true" class="btn pull-right" v-on:click.prevent="gridChange('multiple')"><img src="/static/images/gridview-icon1.png"></button>
                        </div>
                    </div>
                </div>

                <!-- DiscussionData -->
                <div class="internal-container">
                    <div v-show="currentTab == 'discussion'" id="discussionData">
                        <template v-if="discussionData.total_rows > 0">
                            <template v-for="(data, index) in discussionData.discussions">
                                <div v-bind:key="index" class="bulletin-board-listing">
                                    <div class="bullentin-board-listing-top">
                                        <div v-if="data.parent_id != null" class="bullentin-question cursor-default">
                                            {{data.title}} - {{data.menu_title}} ({{data.parent_id_name}})
                                        </div>
                                        <div v-else class="bullentin-question cursor-default">
                                            {{data.title}} -{{data.menu_title}}
                                        </div>
                                        <div>
                                            <!--<b-navbar>
                                                <b-navbar-nav>
                                                    <b-nav-item-dropdown>
                                                        <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'DiscussionEditForm', params:{id:data.id}}">&lt;!&ndash;<i class="fa fa-pencil" aria-hidden="true"></i>&ndash;&gt;Edit</router-link>
                                                        <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.id, 'discussion')">&lt;!&ndash;<i class="fa fa-trash-o"></i>&ndash;&gt;Delete</button>                                                    &lt;!&ndash; <b-dropdown-item href="#">Settings</b-dropdown-item> &ndash;&gt;
                                                    </b-nav-item-dropdown>
                                                </b-navbar-nav>
                                            </b-navbar>-->
                                        </div>
                                    </div>
                                    <div class="floatLeftClass">
                                        <template v-if="data.parent_slug != null">
                                            <router-link v-bind:to="{path: data.parent_slug, params:{id:data.id}}">{{data.parent_id_name}}</router-link>
                                            <a href=""> > </a>
                                        </template>
                                        <template v-if="data.slug != null">
                                            <router-link v-bind:to="{path: data.slug, params:{id:data.id}}">{{data.menu_title}}</router-link>
                                        </template>
                                    </div>
                                    <div class="bulletin-view">
                                        <div class="avtarimg">
                                            <div class="username-letter" >{{getInitials(data.updated_name)}}</div>
                                        </div>
                                        <div class="bulletin-view-details">
                                            <div class="useravtarname">{{formatString(data.updated_name)}}</div>
                                            <div class="bullentininfo">{{utcToLocal(data.updated_at,fullDateFormat)}} &nbsp; | &nbsp;{{utcToLocal(data.updated_at,timeFormat)}}</div>
                                            <div class="bullentintext">
                                                <span v-if="data.description != null" v-html="stringTrim(data.description,500)" v-linkified:options="{ className: '' }"></span>
                                                <template v-if='data.documents.length > 0'>
                                                    <h5>Corresponding Files</h5>
                                                    <div class="attachmentContainer">
                                                        <template>
                                                            <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                                <template v-for="(doc, index1) in data.documents">
                                                                    <template v-if="doc.doc_extension.toLowerCase() == 'gif' || doc.doc_extension.toLowerCase() == 'jpg' || doc.doc_extension.toLowerCase() == 'jpeg' || doc.doc_extension.toLowerCase() == 'png'">
                                                                        <swiper-slide>
                                                                            <img :src="doc.document" :title="doc.document_name" @click="openGallery(data.documents,index1)">
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                        <swiper-slide>
                                                                            <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                        <swiper-slide>
                                                                            <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                        <swiper-slide>
                                                                            <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                        <swiper-slide>
                                                                            <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                    <template v-else>
                                                                        <swiper-slide>
                                                                            <a :href="doc.document" :title="doc.document_name" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                                            <div v-if="doc.document_name.length <= 5" v-b-tooltip.hover.topright :title="doc.document_name" class="document-name">{{ doc.document_name}}</div>
                                                                            <div v-else class="document-name">{{stringTrim(doc.document_name,5)}}</div>
                                                                        </swiper-slide>
                                                                    </template>
                                                                </template>
                                                            </swiper>
                                                        </template>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <div class="">
                                <div class="forms-container">
                                    <div class="error-template">
                                        <div class="error-details no-data-found-error">
                                            No discussions found...!!!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- End DiscussionData -->


                    <div v-show="currentTab == 'attachments'" id="attachemntData">
                        <template v-if="attachmentData.total_rows > 0">
                            <div class="internal-listing-container">
                                <template v-if="is_Grid">
                                    <template v-for="(data, index) in attachmentData.attachments">
                                        <template v-if="data.is_group == 0">
                                            <div class="single-listing">
                                                <div class="upload-doc-img">
                                                    <template v-if="data.data[0].upload_type == 'url'">
                                                        <img src="/static/images/link-icon.png" class="link-icon">
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="data.data[0].documents.length > 0">
                                                            <template v-for="(doc, index1) in data.data[0].documents">
                                                                <template v-if="doc.doc_extension.toLowerCase() == 'gif'">
                                                                    <img src="/static/images/link-icon.png" class="link-icon">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                    <img src="/static/images/doc-icon.png" class="link-icon">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                    <img src="/static/images/xl-icon.png" class="link-icon">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                    <img src="/static/images/ppt-icon.png" class="link-icon">
                                                                </template>
                                                                <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                    <img src="/static/images/pdf-icon.png" class="link-icon">
                                                                </template>
                                                                <template v-else>
                                                                    <img src="/static/images/link-icon.png" class="link-icon">
                                                                </template>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <img src="/static/images/link-icon.png" class="link-icon">
                                                        </template>
                                                    </template>
                                                </div>
                                                <div class="single-listing-text">
                                                    <template v-if="data.data[0].upload_type == 'url'">
                                                        <a :href="data.data[0].url" v-b-tooltip.hover :title="data.data[0].title" target="_blank">{{stringTrim(data.data[0].title,60)}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <span v-b-tooltip.hover :title="data.data[0].title">{{stringTrim(data.data[0].title,60)}}</span>
                                                    </template>
                                                    <div class="customSingleLine">
                                                        <template v-if="data.data[0].parent_slug != null">
                                                            <router-link v-bind:to="{path: data.data[0].parent_slug, params:{id:data.id}}">{{data.data[0].parent_id_name}}</router-link>
                                                            <a href=""> > </a>
                                                        </template>
                                                        <template v-if="data.data[0].slug != null">
                                                            <router-link v-bind:to="{path: data.data[0].slug, params:{id:data.id}}">{{data.data[0].menu_title}}</router-link>
                                                        </template>
                                                    </div>
                                                </div>
                                                <template v-if="data.data[0].upload_type != 'url'">
                                                    <div class="download">
                                                        <template v-for="(doc, index1) in data.data[0].documents">
                                                            <a :href="doc.document" target="_blank">Download</a>
                                                        </template>
                                                    </div>
                                                </template>
                                                <div class="listing-user-info">
                                                    <div v-if="user_role == 1">
                                                        <!--<b-navbar>
                                                            <b-navbar-nav>
                                                                <b-nav-item-dropdown>
                                                                    <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.data[0].id}}">&lt;!&ndash;<i class="fa fa-pencil" aria-hidden="true"></i>&ndash;&gt;Edit</router-link>
                                                                    <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.data[0].id, 'attachment')">&lt;!&ndash;<i class="fa fa-trash-o"></i>&ndash;&gt;Delete</button>
                                                                    &lt;!&ndash; <b-dropdown-item href="#">Settings</b-dropdown-item> &ndash;&gt;
                                                                </b-nav-item-dropdown>
                                                            </b-navbar-nav>
                                                        </b-navbar>-->
                                                    </div>
                                                    <div class="listing-user">{{formatString(data.data[0].updated_name)}}</div>
                                                    <div class="listing-block-info">
                                                        <div class="listing-date">{{utcToLocal(data.data[0].updated_at,dateFormat)}}</div>
                                                        <div class="listing-time">{{utcToLocal(data.data[0].updated_at,timeFormat)}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="single-listing"  v-on:click="showGroupDiv(data.group_id)">
                                                <div class="upload-doc-img">
                                                    <img src="/static/images/folder-icon.png" class="link-icon">
                                                </div>
                                                <div class="single-listing-text">
                                                    <span v-b-tooltip.hover :title="data.group_name">{{stringTrim(data.group_name,60)}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="three-column-listing">
                                        <template v-for="(data, index) in attachmentData.attachments">
                                            <template v-if="data.is_group == 0">
                                                <div v-bind:key="index" class="three-column-listing-block">
                                                    <div class="upload-doc-img">
                                                        <template v-if="data.data[0].upload_type == 'url'">
                                                            <img src="/static/images/link-icon.png">
                                                        </template>
                                                        <template v-else>
                                                            <template v-for="(doc, index1) in data.data[0].documents">
                                                                <div v-bind:key="index1">
                                                                    <template v-if="doc.doc_extension.toLowerCase() == 'gif'">
                                                                        <img src="/static/images/link-icon.png">
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'doc' || doc.doc_extension.toLowerCase() == 'docx'">
                                                                        <img src="/static/images/doc-icon.png">
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'xls' || doc.doc_extension.toLowerCase() == 'xlsx'">
                                                                        <img src="/static/images/xl-icon.png">
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'ppt' || doc.doc_extension.toLowerCase() == 'pptx'">
                                                                        <img src="/static/images/ppt-icon.png">
                                                                    </template>
                                                                    <template v-else-if="doc.doc_extension.toLowerCase() == 'pdf'">
                                                                        <img src="/static/images/pdf-icon.png">
                                                                    </template>
                                                                    <template v-else>
                                                                        <img src="/static/images/link-icon.png">
                                                                    </template>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </div>
                                                    <div class="three-column-right">
                                                        <div class="three-column-right-container">
                                                            <div v-if="user_role == 1">
                                                                <!--<b-navbar>
                                                                    <b-navbar-nav>
                                                                        <b-nav-item-dropdown>
                                                                            <router-link class="btn btn-primary pull-right" v-bind:to="{name: 'AttachmentEditForm', params:{id:data.data[0].id}}">&lt;!&ndash;<i class="fa fa-pencil" aria-hidden="true"></i>&ndash;&gt;Edit</router-link>
                                                                            <button class="btn btn-primary pull-right" v-on:click.prevent="deleteDiscussion(data.data[0].id, 'attachment')">&lt;!&ndash;<i class="fa fa-trash-o"></i>&ndash;&gt;Delete</button>
                                                                            &lt;!&ndash; <b-dropdown-item href="#">Settings</b-dropdown-item> &ndash;&gt;
                                                                        </b-nav-item-dropdown>
                                                                    </b-navbar-nav>
                                                                </b-navbar>-->
                                                            </div>
                                                            <span>
                                                                        <template v-if="data.data[0].upload_type == 'url'">
                                                                            <span v-if="data.data[0].title.length <= 20" v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                            <span v-else v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span v-if="data.data[0].title.length <= 20" v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                            <span v-else v-b-tooltip.hover.topright :title="data.data[0].title">{{stringTrim(data.data[0].title,20)}}</span>
                                                                        </template>
                                                                    </span>
                                                            <div class="listing-block-info">
                                                                <div class="listing-date">{{utcToLocal(data.data[0].updated_at,dateFormat)}}</div>
                                                                <div class="listing-time">{{utcToLocal(data.data[0].updated_at,timeFormat)}}</div>
                                                            </div>
                                                        </div>
                                                        <template v-if="data.data[0].upload_type != 'url'">
                                                            <template v-for="(doc, index1) in data.data[0].documents">
                                                                <a v-bind:key="index1" :href="doc.document" class="downloadnow" target="_blank">Download Now!</a>
                                                            </template>
                                                        </template>
                                                        <template v-else>
                                                            <a :href="data.data[0].url" class="downloadnow" target="_blank">Visit Now!</a>
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div v-bind:key="index" class="three-column-listing-block" v-on:click="showGroupDiv(data.group_id)">
                                                    <div class="upload-doc-img">
                                                        <img src="/static/images/folder-icon.png">
                                                    </div>
                                                    <div class="three-column-right">
                                                        <div class="three-column-right-container">
                                                                    <span>
                                                                        <span v-if="data.group_name <= 20" v-b-tooltip.hover.topright :title="data.group_name">{{stringTrim(data.group_name,20)}}</span>
                                                                        <span v-else v-b-tooltip.hover.topright :title="data.group_name">{{stringTrim(data.group_name,20)}}</span>
                                                                    </span>
                                                            <div class="listing-block-info">
                                                                <div class="listing-date">&nbsp;</div>
                                                                <div class="listing-time">&nbsp;</div>
                                                            </div>
                                                        </div>
                                                        <template>
                                                            &nbsp;
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </template>
                                <!--<div v-if="attachmentData.total_rows >= attachmentData.per_page">
                                    <b-pagination align="center"
                                                  prev-text="‹ Previous"
                                                  next-text="Next ›" :total-rows="attachmentData.total_rows" v-model="attachmentCurrentPage" :per-page="attachmentData.per_page"></b-pagination>
                                </div>-->
                            </div>
                        </template>
                        <template v-else>
                            <div class="">
                                <div class="forms-container">
                                    <div class="error-template">
                                        <div class="error-details no-data-found-error">
                                            No attachments found...!!!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import EventBus from './event-bus';
    import {commonMixins} from '../mixins/commonMixins';
    import {HTTP} from '../http-common.js';
    /* Swiper for submenu tebs start */
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    /* Swiper for submenu tebs end */
    var contex;

    export default {
        name: "GlobalSearch",
        mixins: [commonMixins],
        components: {
            swiper,
            swiperSlide,
        },
        data: () => ({
            swiperOptionAttachments: {
                slidesPerView: 14.5,
                spaceBetween: 8,
                freeMode: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    1500: {
                        slidesPerView: 12.5
                    },
                    1400: {
                        slidesPerView: 11.5
                    },
                    1300: {
                        slidesPerView: 10.4
                    },
                    1200: {
                        slidesPerView: 8.5
                    },
                    1000: {
                        slidesPerView: 7.5
                    },
                    667: {
                        slidesPerView: 5.5
                    },
                    480: {
                        slidesPerView: 3.5
                    },
                    360: {
                        slidesPerView: 3.4
                    }
                }
            },
            discussionData : [],
            attachmentData : [],
            groupAttachmentsResult : [],
            currentTab : "discussion",
            is_Grid: true,
            globalSearchText : "",
            dateFormat: process.env.DISPLAY_DATE_FORMAT,
            timeFormat: process.env.DISPLAY_TIME_FORMAT,
            fullDateFormat: process.env.DISPLAY_FULL_DATE_FORMAT
        }),
        beforeMount: function () {
            contex = this;
        },
        destroyed : function() {
            var self = this;
            EventBus.$emit("on-globalsearch");
            self.globalSearchText = "";

        },
        watch: {
            '$route': function () {
                var self = this;
                self.globalSearchText = this.$route.params.searchText;
                self.loadSalesPost();
                self.loadSalesAttachment();
            },
        },
        mounted: function () {
            var self = this;
            self.globalSearchText = this.$route.params.searchText;
            self.loadSalesPost();
            self.loadSalesAttachment();
            self.changeTab('discussion');
        },
        methods: {
            /* display single or multiple grid wise data */
            gridChange: function (gridFlag) {

                var self = this;
                if (gridFlag != "single") {
                    self.is_Grid = false;
                } else {
                    self.is_Grid = true;
                }
            },
            viewDetails: function (id) {
                var self = this;
                localStorage.setItem("post_id", id);
                self.$router.push({name: 'CommonPostDetail', params: {type: self.menuSlug}});
            },
            /* display user name in formated string */
            formatString: function (data) {
                data = (data === null || typeof data === "undefined") ? '' : data;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            /*get user's initials from firstname lastname */
            getInitials: function (string) {
                var names = string.split(' ');
                var initials = "";
                $.each(names, function (i) {
                    initials += names[i].charAt(0);
                });
                return initials.toUpperCase();
            },
            changeTab: function (tab) {
                var self = this;
                self.currentTab = tab;
                if (tab == "discussion") {
                    $(".btnDiscussion").removeClass("btn-outline-primary");
                    $(".btnDiscussion").addClass("btn-primary");
                    $(".btnAttachment").removeClass("btn-primary");
                    $(".btnAttachment").addClass("btn-outline-primary");
                } else {
                    $(".btnAttachment").removeClass("btn-outline-primary");
                    $(".btnAttachment").addClass("btn-primary");
                    $(".btnDiscussion").removeClass("btn-primary");
                    $(".btnDiscussion").addClass("btn-outline-primary");
                }
            },
            /* Display Save the date End*/
            /* Display Sales Post Start*/
            loadSalesPost: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'filter': self.globalSearchText,
                    }
                };
                self.showLoader();
                HTTP.get("global_search_sales_post", config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.discussionData = response.data.content;
                            /*if (response.data.content.length <= 0) {
                                self.discussionCurrentPage = 1;
                            }*/
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            /* Display Sales Post End*/
            /* Display Sales Attachments Start*/
            loadSalesAttachment: function () {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'filter': self.globalSearchText,
                    }
                };
                self.showLoader();
                HTTP.get("global_search_sales_attachement", config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.attachmentData = response.data.content;
                            self.groupAttachmentsResult = response.data.content.groupAttachmentsResult;
                            /*if (response.data.content.length <= 0) {
                                self.attachmentCurrentPage = 1;
                            }*/
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },

        },

    };
    /*EventBus.$on('on-globalsearch', function (data) {
        var self = this;
        // console.log('Event Called');
        console.log('Event Called' + data);
        if (typeof (contex) != 'undefined') {
            self.$nextTick(() => {
                self.searchText = data;
                contex.loadSalesPost();
                contex.loadSalesAttachment();
            });
        }
    });*/

</script>


// WEBPACK FOOTER //
// src/components/GlobalSearchView.vue